import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return (
    <div className="min-h-[40vh] flex items-center justify-center text-muted-foreground">جاري التحميل...</div>
  );
  if (!user || !user.id) return <Navigate to="/login" replace state={{ from: `${loc.pathname}${loc.search}` }} />;
  if (role && user.role !== role && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
